import { PopoverPosition } from "@mui/material/Popover";
import { useState } from "react";

import { AddResourceMenuProps } from "./AddResourceMenu";

const SHOW_MENU_OFFSET = 130;

export const useAddResourceMenu = (): Omit<AddResourceMenuProps, "fileLabel" | "manualLabel"> => {
  const [anchorPosition, setAnchorPosition] = useState<PopoverPosition>();
  const open = Boolean(anchorPosition);

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorPosition({
      top: event.currentTarget.offsetTop + SHOW_MENU_OFFSET,
      left: event.currentTarget.offsetLeft
    });
  };

  const handleClose = () => {
    setAnchorPosition(undefined);
  };

  return {
    open,
    handleOpen,
    handleClose,
    anchorPosition
  };
};
